<template>
  <div class="basic">
    <div class="basic-header">
      <p>- 企业基本信息 -</p>
    </div>
    <van-form label-width="7em" @submit="handleSubmit" validate-first ref="basicForm">
      <!-- 企业基本信息   -->
      <van-field
        required
        v-model="formInline.companyName"
        name="companyName"
        label="企业名称"
        placeholder="企业名称（必须和营业执照一致）"
        :rules="ruleInline.companyName"
      />
      <van-field
        required
        v-model="formInline.companyNameShort"
        name="companyNameShort"
        label="简称"
        placeholder="简称（2~5个字）"
        :rules="ruleInline.companyNameShort"
      />
      <van-field
        v-model="formInline.companyNameEn"
        name="companyNameEn"
        label="英文名称"
        placeholder="企业英文名称"
        :rules="ruleInline.companyNameEn"
      />
      <van-field
        v-model="formInline.companyNameShortEn"
        name="companyNameShortEn"
        label="英文简称"
        placeholder="企业英文简称"
        :rules="ruleInline.companyNameShortEn"
      />
      <van-field
        required
        v-model="formInline.creditCode"
        name="creditCode"
        label="信用代码"
        placeholder="统一社会信用代码"
        :rules="ruleInline.creditCode"
      />
      <div>
        <van-field
          required
          readonly
          clickable
          name="addresss"
          :value="selectAddresTxt"
          right-icon="arrow"
          label="公司地址"
          placeholder="请选择公司地址"
          :rules="ruleInline.addresss"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker show-toolbar :columns="areaList" @confirm="onConfirm" />
        </van-popup>
      </div>
      <van-field
        v-model="formInline.address"
        name="address"
        label="详细地址"
        placeholder="请输入详细地址"
        :rules="ruleInline.address"
        required
      />
      <van-field
        v-model="formInline.postcode"
        name="postcode"
        label="邮编"
        placeholder="请输入邮编"
        :rules="ruleInline.postcode"
      />
      <!-- 企业基本信息 end  -->

      <div class="gap"></div>

      <!-- 展会联系人信息   -->
      <div class="top-title">
        <div class="line"></div>
        展会联系人<span>*</span>
      </div>

      <van-field
        required
        v-model="formInline.linkMan"
        name="linkMan"
        label="姓名"
        placeholder="展会联系人姓名"
        :rules="ruleInline.linkMan"
      />
      <van-field
        required
        v-model="formInline.linkTitle"
        name="linkTitle"
        label="职务"
        placeholder="展会联系人职务"
        :rules="ruleInline.linkTitle"
      />
      <van-field
        type="number"
        required
        v-model="formInline.linkMob"
        name="linkMob"
        label="手机"
        placeholder="展会联系人手机 "
        :rules="ruleInline.linkMob"
      />
      <van-field
        required
        v-model="formInline.linkEmail"
        name="linkEmail"
        label="邮箱"
        placeholder="展会联系人邮箱"
        :rules="ruleInline.linkEmail"
      />
      <van-field
        v-model="formInline.linkTelephone"
        name="linkTelephone"
        label="座机电话"
        placeholder="座机电话号码（示例：051-85055112）"
        :rules="ruleInline.linkTelephone"
      />
      <van-field
        type="number"
        v-model="formInline.linkQQ"
        name="linkQQ"
        label="QQ"
        placeholder="展会联系人QQ"
      />
      <van-field
        v-model="formInline.linkWeChat"
        name="linkWeChat"
        label="微信"
        placeholder="展会联系人微信"
      />
      <!-- 展会联系人信息 end -->

      <div class="gap"></div>

      <!-- <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div> -->
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import mFormAddress from "@components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import country from "@assets/js/country2";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    const zhValid = (value, callback) => {
      if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    // 判断英文
    const enValid = (value, callback) => {
      if (!value) {
        return true;
      } else {
        if (/^(?!\s*$)[A-Za-z0-9.,_\-\&\(\)\（）\s-]+$/.test(value)) {
          return true;
        } else {
          // callback(new Error('英文名称格式有误'));
          return false;
        }
      }
    };
    const companyAddressValid = (value) => {
      if (
        that.formInline.addresss.country &&
        that.formInline.addresss.country === "中国"
      ) {
        // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          return false;
        } else if (!that.formInline.addresss.city) {
          return false;
        } else {
          return true;
        }
      } else {
        if (that.formInline.addresss.country) {
          return true;
        } else {
          return false;
        }
      }
    };
    const validPhone = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^[1][0-9]{10}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validEmail = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validCreditCode = (value, callback) => {
      if (!value) {
        return true;
      }
      var patrn = /^[0-9A-Z]+$/;
      //var patrn=/[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
      //18位校验及大写校验
      console.log(patrn.test(value), "正则的数据");
      if (value.length != 18 || patrn.test(value) == false) {
        return false;
      } else {
        return true;
      }
    };
    return {
      areaList: [],
      showPicker: false,
      showPicker2: false,
      cityCode: "", //省市区编号，默认
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "", // 公司英文名称
        companyNameShortEn: "", // 公司英文名称
        creditCode: "", // 统一社会信用代码
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        postcode: "",

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",
      },
      formInline2: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan", // 公司英文名称
        companyNameShortEn: "lianzhan", // 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        postcode: "201803",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "051-85055112", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "onBlur" },
          // { validator: zhValid, message: "公司名称格式有误", trigger: "onBlur" },
        ],
        creditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "onBlur",
          },
          {
            message: "请输入正确的统一社会信用代码",
            validator: validCreditCode,
            trigger: "onBlur",
          },
        ],
        companyNameShort: [
          { required: true, message: "请输入公司简称", trigger: "onBlur" },
          {
            validator: (value) => {
              return /^.{2,5}$/.test(value);
            },
            message: "公司简称长度在2到5个字符",
            trigger: "onBlur",
          },
        ],
        companyNameEn: [
          { message: "请输入公司英文名称", trigger: "onBlur" },
          { validator: enValid, message: "英文名称格式有误", trigger: "onBlur" },
        ],
        addresss: [
          {
            required: true,
            validator: companyAddressValid,
            trigger: "onBlur",
            message: "完善地址",
          },
        ],
        address: [{ required: true, message: "请输入详细地址", trigger: "onBlur" }],

        // 展会联系人
        linkMan: [{ required: true, message: "请输入姓名", trigger: "onBlur" }],
        linkTitle: [{ required: true, message: "请输入职务", trigger: "onBlur" }],
        linkMob: [
          { required: true, message: "请输入手机号码", trigger: "onBlur" },
          { validator: validPhone, message: "手机号码有误", trigger: "onBlur" },
        ],
        linkTelephone: [{ required: true, message: "请输入座机电话", trigger: "onBlur" }],
        linkEmail: [
          { required: true, message: "请输入邮箱", trigger: "onBlur" },
          {
            validator: validEmail,
            message: "邮箱地址有误",
            trigger: "onBlur",
          },
        ],
      },
      defaultList: [],
      uploadList: [],
      uploadName: "",

      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新技术企业

      basicInfo: null,
      validateList: [],
      companyId: "", //公司ID

      countryList: [],
      provinceArr: [],
      citiesArr: [],

      selectAddresTxt: "",
      selectAddresTxt2: "中国/上海/嘉定",
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId() {
      return this.$route.query.userId;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
  },
  created() {
    this.areaList = country;
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),
    getvalidate(prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    addAreaArr() {
      if (this.formInline.exportSalesArea.length > 4) {
        Toast.warning("最多可选五个");
        return;
      }
      this.formInline.exportSalesArea.push([]);
    },
    delAreaArr(i) {
      this.formInline.exportSalesArea.splice(i, 1);
    },
    async handleSubmit() {
      Toast.loading("验证中...");
      setTimeout(() => {
        Toast.clear();
      }, 5000);
      let res = await this.validateHandle();
      Toast.clear();
      return Promise.resolve(res);
    },
    async validateHandle() {
      return new Promise((resolve, reject) => {
        this.$refs.basicForm
          .validate()
          .then(() => {
            // 营业执照
            let valid = true;
            let codeNum = this.formInline.linkMob.split("-");
            if (codeNum.length === 2) {
              this.formInline.linkCode = codeNum[0];
              this.formInline.linkMob = codeNum[1];
            }
            let form = this.formInline;
            console.log("form", this.formInline);

            let formValue = {
              companyName: form.companyName, // 公司名称
              companyNameShort: form.companyNameShort, // 公司简称
              companyNameEn: form.companyNameEn, // 公司英文名称
              companyNameShortEn: form.companyNameShortEn, // 公司英文名称
              unifiedCode: form.creditCode, // 统一社会信用代码
              address: form.address, // 详细地址
              country: form.addresss.country,
              province: form.addresss.province,
              city: form.addresss.city,

              postcode: form.postcode,

              // 展会联系人
              linkMan: form.linkMan,
              linkTitle: form.linkTitle,
              linkTelephone: form.linkTelephone,
              linkEmail: form.linkEmail,
              linkCode: form.linkCode, // 区号
              linkMob: form.linkMob, // 电话号码
              linkQQ: form.linkQQ,
              linkWeChat: form.linkWeChat,
            };
            resolve({ valid: valid, form: formValue });
          })
          .catch((res) => {
            //验证失败
            console.log(res);
            this.$refs.basicForm.scrollToField(res[0].name, true);
            Toast.fail(res[0].message);
            resolve({ valid: false, form: null });
          });
      });
    },
    onConfirm(value) {
      this.formInline.addresss.country = value[0] || "";
      this.formInline.addresss.province = value[1] || "";
      this.formInline.addresss.city = value[2] || "";
      this.selectAddresTxt = `${
        this.formInline.addresss.country ? this.formInline.addresss.country : ""
      }${
        this.formInline.addresss.province ? "/" + this.formInline.addresss.province : ""
      }${this.formInline.addresss.city ? "/" + this.formInline.addresss.city : ""}`;
      this.showPicker = false;
    },
  },
};
</script>

<style scoped lang="scss">
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #4f65ae !important;
    }
    .van-switch--on,
    .ivu-radio-inner:after {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
    .van-button--info,
    .van-radio__icon--checked .van-icon,
    .ivu-switch-checked {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }
  &-header {
    width: 100%;
    height: 48px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 48px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;
    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-top: 33px;
      margin-bottom: 10px;
    }
    div {
      font-size: 12px;
      color: #999;
    }
  }
  .license-img {
    display: flex;
    flex-wrap: wrap;
    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      span {
        color: #4f65ae;
        cursor: pointer;
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    .ivu-checkbox-wrapper {
      margin: 0;
    }
    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
.tip {
  padding: 10px 16px 0;
  .red {
    font-size: 12px;
    color: #f00;
  }
  .txt1 {
    font-size: 13px;
    color: #000;
    font-weight: bold;
  }
  .txt2 {
    font-size: 12px;
    color: #999;
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.upload-btn2 {
  width: 105px;
  height: 105px;
  border: dotted 1px #bfbfbf;
  text-align: center;
  margin: 10px 16px;
  border-radius: 4px;
  position: relative;
  margin-left: 10px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .cover {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 3;
    .icon {
    }
  }
}
</style>
